import Format from "../components/format/Format";

export default function Markdown() {

    return (
        <Format inputLabel='Markdown' 
            buttons={[
                {
                    api: '/api/markdown/html',
                    buttonLabel: 'To HTML',
                    outputLabel: 'HTML',
                },
            ]} 
        />
    );
}